import React from 'react'
import { Box, BoxProps, BoxTypeMap } from '@mui/material'

type ScrollableProps<
  D extends React.ElementType = BoxTypeMap['defaultComponent']
> = BoxProps<
  D,
  {
    allowHorizontal?: boolean
    allowVertical?: boolean
  }
>

const Scrollable = ({ children, ...props }: ScrollableProps) => {

  const wrapperRef = React.useRef<HTMLDivElement>()

  React.useEffect(() => {
    if (!wrapperRef.current) return

    // console.log();
  }, [wrapperRef])

  const {
    allowHorizontal = false,
    allowVertical = true,
    maxHeight = '100%',
    maxWidth = '100%',
    sx,
    ...boxProps
  } = props

  return (
    <Box ref={wrapperRef} sx={{
      maxHeight: maxHeight,
      maxWidth: maxWidth,
      width: '100%',
      padding: 0,
      overflowX: !allowHorizontal ? 'hidden' : 'scroll',
      overflowY: !allowVertical ? 'hidden' : 'scroll',
      ...sx
    }}
    {...boxProps}
    >
      {children}
    </Box>
  )
}

export default Scrollable
